import React from 'react';
import { Outlet, useParams, useLocation } from 'react-router-dom';
import PlatformFooter from '../../components/PlatformFooter';
import TenantHeader from '../../components/TenantHeader';
import { useTenant } from '../../context/TenantContext';
import { useComsAvailability } from '../../context/ComsContext';
import { useAuth } from '../../context/AuthContext';
import { communityNavigation } from '../../utils/communityNavigation';

/**
 * TenantShell — layout shell for the /t/:tenantSlug route tree.
 *
 * Both platform staff/admin and community members see the same branded
 * TenantHeader; platform staff/admin additionally get a "← Platform" preview
 * strip above it so it's clear they're viewing someone else's tenant.
 */
const TenantShell = () => {
  const location = useLocation();
  const { tenantSlug } = useParams();
  const { viewTenant, viewerRole, isViewModuleEnabled, isPlatformStaff } = useTenant();
  const { comsEnabled } = useComsAvailability();
  const { user } = useAuth();
  const isEmbedded = new URLSearchParams(location.search).get('embedded') === '1';

  const base = `/t/${tenantSlug}`;
  const nav = [
    ...communityNavigation({ base, tenantId: viewTenant?._id, user, role: viewerRole, enabled: isViewModuleEnabled }),
    comsEnabled && isViewModuleEnabled('coms') && { to: '/coms', label: '💬 Coms Hub' },
  ].filter(Boolean);

  const banner = viewTenant?.branding?.bannerText && (
    <div className="shell-community-banner">{viewTenant.branding.bannerText}</div>
  );

  if (isEmbedded) {
    return (
      <main className="shell-content--full shell-content--embedded">
        <Outlet />
      </main>
    );
  }

  return (
    <div className="shell shell--tenant">
      <TenantHeader
        tenant={viewTenant}
        navItems={nav}
        previewBackTo={isPlatformStaff ? '/dashboard' : undefined}
        previewLabel={isPlatformStaff ? `Previewing as ${viewerRole}` : undefined}
      />
      {banner}
      <main className="shell-content--full">
        <Outlet />
      </main>
      <PlatformFooter />
    </div>
  );
};

export default TenantShell;
